var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.713 8.362C9.633 9.572 7.92 10.347 6 10.347l-2.847 1.561c-.48.273-1.091-.1-1.026-.614L2.4 9.309C.938 8.372 0 6.871 0 5.18 0 3.404 1.025 1.843 2.596.916 3.567.332 4.735 0 6 0c3.316 0 6 2.317 6 5.178 0 1.2-.48 2.308-1.287 3.184z",
    fill: "#FFFFFD",
    fillOpacity: 0.988
  })));
}
export default SvgQuote;